<div class="bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-purple-900/20">
  <particles [quantity]="120">
    <section class="pt-24 pb-12 px-6 lg:px-8 max-w-4xl mx-auto">
      <header class="mb-8">
        <h1 class="text-4xl font-light text-foreground">Privacy Policy</h1>
        <p class="text-sm text-muted-foreground mt-2">Last updated: {{ '2024-01-01' }}</p>
      </header>
  
      <div class="space-y-8 text-muted-foreground leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Introduction</h2>
          <p>We value your privacy. This policy explains what data we collect, how we use it, and your rights.</p>
        </section>
  
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Data We Collect</h2>
          <ul class="list-disc pl-5 space-y-2">
            <li>Account data: name, email, company.</li>
            <li>Usage data: app interactions, device information.</li>
            <li>Optional: integrations and connected accounts.</li>
          </ul>
        </section>
  
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">How We Use Data</h2>
          <p>To provide and improve the service, support, security, analytics, and legal compliance.</p>
        </section>
  
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Your Rights</h2>
          <p>You can access, correct, delete, or export your data, and object to certain processing.</p>
        </section>
  
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Contact</h2>
          <p>{{'Questions? Contact us at privacy@yourdomain.com.'}}</p>
        </section>
      </div>
    </section>
  </particles>
</div>
